import type { ReactNode, SVGProps } from 'react'

/**
 * Schrijfrecht op een sectie, in de inhoudsopgave van wie via een deling binnenkwam (R-65, R-139).
 *
 * Een tekstcursor en geen potlood: het potlood betekent in de inhoudsopgave "vraagt aanpassing" en één
 * icoon heeft daar één betekenis (audit R-13).
 */
export function CursorIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-3)', height: 'var(--nwo-space-sp-3)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <path d="M9 4h6M9 20h6M12 4v16" />
    </svg>
  )
}
